import { ReactElement } from 'react';
import { Column, Modal } from 'carbon-components-react';
import { FormattedMessage } from 'react-intl';
import '../style/responseModal.scss';

export interface modalMessageProperties {
  setShowResponseModal: React.Dispatch<React.SetStateAction<boolean>>;
  showResponseModal: boolean;
  textResponse: string[];
  messages: any;
  modalTitle: string;
}

export const ModalMessage = ({
  showResponseModal: showModal,
  setShowResponseModal: setShowModal,
  textResponse,
  messages,
  modalTitle,
}: modalMessageProperties): ReactElement => {
  const render = (
    <div className="ResponseModal">
      <div className="bx-row">
        <Column sm={4} md={16} lg={16}>
          <Modal
            id="idx"
            open={showModal}
            modalHeading={modalTitle}
            primaryButtonText={<FormattedMessage {...messages.modalContinue} />}
            onRequestClose={() => {
              setShowModal(false);
            }}
            onRequestSubmit={() => {
              setShowModal(false);
            }}
          >
            {textResponse.map((object, idx) => (
              <p key={`idx-${idx}`} className="mar5">
                <span className="slide_text">{object}</span>
                <br />
              </p>
            ))}
            <br />
          </Modal>
        </Column>
      </div>
    </div>
  );
  return render;
};
